let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kgEQN")).then(() => parcelRequire('52NTL'));